import {useMemo} from "react";
import {TypeOf} from "zod";
import {useAccessToken} from "../auth";
import {useClientId} from "../ClientIdProvider";
import {
	createApiClientWithBaseConfig,
	get_QuerySubscriptions,
	SubscriptionCancellation,
	SubscriptionCreation,
} from "./client";

export type SubscriptionQuery = TypeOf<get_QuerySubscriptions["parameters"]>["query"];

export function useSubscriptionApi() {
	const accessToken = useAccessToken();
	const clientId = useClientId();
	return useMemo(() => createSubscriptionApi(clientId, accessToken), [clientId, accessToken]);
}

function createSubscriptionApi(clientId: string | undefined, accessToken: string | undefined) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, accessToken);
	return {
		querySubscriptions: (query: SubscriptionQuery) =>
			api.get(
				"/api/subscriptions",
				withConfig({
					query,
				}),
			),
		getSubscription: (subscriptionId: number) =>
			api.get(
				"/api/subscriptions/{subscriptionId}",
				withConfig({
					path: {subscriptionId},
				}),
			),
		createSubscription: (creation: SubscriptionCreation) =>
			api.post(
				"/api/subscriptions",
				withConfig({
					body: creation,
				}),
			),
		cancelSubscription: (subscriptionId: number, cancellation: SubscriptionCancellation) =>
			api.put(
				"/api/subscriptions/{subscriptionId}/cancel",
				withConfig({
					path: {subscriptionId},
					body: cancellation,
				}),
			),
	};
}
